// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";

function execute(result) {
  return {
          customer_reasons: List.map((function (reason) {
                  return {
                          key: String(reason.id),
                          value: reason.name,
                          text: reason.name
                        };
                }), result.customer_reasons),
          partner_reasons: List.map((function (reason) {
                  return {
                          key: String(reason.id),
                          value: reason.name,
                          text: reason.name
                        };
                }), result.partner_reasons),
          allocation_reasons: List.map((function (reason) {
                  return {
                          key: String(reason.id),
                          value: reason.name,
                          text: reason.name
                        };
                }), result.allocation_reasons)
        };
}

export {
  execute ,
  
}
/* No side effect */
